import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PolicyOverviewPageComponent, CreatePolicyPageComponent } from '@htx/policies';

const routes: Routes = [
  { path: '', component: PolicyOverviewPageComponent },
  { path: 'create', component: CreatePolicyPageComponent },
  { path: 'edit/:id', component: CreatePolicyPageComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PoliciesRoutingModule {}
